/**
 * AI Chat Constants
 * Matches backend enums in OrbitalX.Business.Enums.AI
 */

/**
 * Chat message roles (matches ChatMessageRoles in backend)
 */
export const ChatMessageRoles = {
  System: 'system',
  User: 'user',
  Assistant: 'assistant',
  Function: 'function',
} as const

export type ChatMessageRole = typeof ChatMessageRoles[keyof typeof ChatMessageRoles]

/**
 * Chat entity types (matches ChatEntityType enum)
 * These represent the type of entity being viewed/edited
 */
export const ChatEntityTypes = {
  None: 'None',
  Campaign: 'Campaign',
  Web: 'Web',
  TouchPoint: 'TouchPoint',
  Asset: 'Asset',
} as const

export type ChatEntityType = typeof ChatEntityTypes[keyof typeof ChatEntityTypes]

/**
 * Chat locations (matches ChatLocation enum)
 * These represent where in the app the user is
 */
export const ChatLocations = {
  CampaignList: 'Campaign List',
  CampaignDetails: 'Campaign Details',
  CampaignEditor: 'Campaign Editor',
  CampaignAudience: 'Campaign Audience',
  CampaignWebs: 'Campaign Webs',
  CampaignLeads: 'Campaign Leads',
  CampaignMeetings: 'Campaign Meetings',
  CampaignCalendar: 'Campaign Calendar',
  CampaignAnalytics: 'Campaign Analytics',
  CampaignSettings: 'Campaign Settings',
  WebEditor: 'Web Editor',
  WebDownloadEditor: 'Web Download Editor',
  WebQuizEditor: 'Web Quiz Editor',
  WebMeetingEditor: 'Web Meeting Editor',
  WebDemoEditor: 'Web Demo Editor',
  WebOnlineEventEditor: 'Web Online Event Editor',
  WebSpeakerEditor: 'Web Speaker Editor',
  WebLeads: 'Web Leads',
  WebMeetings: 'Web Meetings',
  WebCalendar: 'Web Calendar',
  WorkspaceCalendar: 'Workspace Calendar',
  WebAssets: 'Web Assets',
  WebAssetEditor: 'Web Asset Editor',
  WorkspaceSettings: 'Workspace Settings',
  WorkspaceDashboard: 'Workspace Dashboard',
  TouchPointEditor: 'TouchPoint Editor',
  LandingPageGenerator: 'Landing Page Generator',
  EmailAssetEditor: 'Email Asset Editor',
  // The console's thread surfaces. Each names itself because the API gates the console's tools
  // by location; the strings must equal the C# `ChatLocation` descriptions.
  ConsoleFrontDoor: 'Console Front Door',
  ConsoleProspects: 'Console Prospects',
  ConsoleCampaigns: 'Console Campaigns',
  Other: 'Other',
} as const

export type ChatLocation = typeof ChatLocations[keyof typeof ChatLocations]

/**
 * Chat view modes (matches ChatViewMode enum)
 */
export const ChatViewModes = {
  View: 'View',
  Edit: 'Edit',
  Create: 'Create',
} as const

export type ChatViewMode = typeof ChatViewModes[keyof typeof ChatViewModes]
